import {
  IconNameEnum,
  useFlightStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import {
  FlightExchangeTripDetailsCard,
  useFlightExchangeConfirmation,
} from "@tenant/flights";
import { Icon, Loading, Page } from "@tenant/ui";
import clsx from "clsx";

import defaultStyles from "./FlightExchangeConfirmation.module.scss";

export type FlightExchangeConfirmationProps = PlatformComponentProps;

export const FlightExchangeConfirmation = (
  props: FlightExchangeConfirmationProps
) => {
  const { className } = props;
  const COMPONENT_KEY = CoreFlightsComponent.FlightExchangeConfirmation;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const {
    context: { itineraryDetails, loading },
    handlers,
    text,
  } = useFlightExchangeConfirmation();

  return loading ? (
    <Loading />
  ) : (
    <Page className={clsx(block, className)}>
      <div className={cn("exchange-confirmation-page-content")}>
        <div className={cn("exchange-confirmation-header")}>
          <div className={cn("exchange-status")}>
            <Icon
              useCurrentColor
              className={cn("exchange-status-icon")}
              iconName={IconNameEnum.checkFilled}
            />
            {text.status}
          </div>
          <span className={cn("exchange-completed-title")}>
            {text.pageTitle}
          </span>
          {text.pageBody == null ? null : (
            <span className={cn("exchange-completed-description")}>
              {text.pageBody}
            </span>
          )}
          {itineraryDetails?.locator == null ? null : (
            <div className={cn("confirmation-code")}>
              <span className={cn("confirmation-code-title")}>
                {text.confirmationCodeLabel}
              </span>
              <span className={cn("confirmation-code-value")}>
                {itineraryDetails.locator}
              </span>
            </div>
          )}
        </div>
        <FlightExchangeTripDetailsCard />
        <div
          className={cn("updated-itinerary-cta")}
          onClick={handlers.goToMyTrips}
        >
          <Icon iconName={IconNameEnum.itinerary} />
          {text.viewTripDetailsCta}
        </div>
      </div>
    </Page>
  );
};
